import { render, staticRenderFns } from "./StandardDialogFullScreen.component.vue?vue&type=template&id=32741ac4&"
import script from "./StandardDialogFullScreen.component.vue?vue&type=script&lang=js&"
export * from "./StandardDialogFullScreen.component.vue?vue&type=script&lang=js&"
import style0 from "./StandardDialogFullScreen.component.vue?vue&type=style&index=0&id=32741ac4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports